import React, { type JSX } from "react";
import { twMerge } from "tailwind-merge";

import { SupText as Text } from "../../../components/UI/Text";
import { SupBadge as Badge } from "./Badge";
import type { CommonColors } from "../../../types/colors";

export interface ProgressBadgeProps {
  label: string;
  color?: CommonColors;
  variant?: "count" | "icon";
  small?: boolean;
  className?: string;
  count?: number;
  icon?: JSX.Element;
}

export const SupProgressBadge = ({ label, variant = "count", small = true, color = "info", className, count, icon }: ProgressBadgeProps) => (
  <span className={twMerge("inline-flex justify-center items-center", className)}>
    <Badge variant={`${variant}${small ? "-small" : ""}`} color={color} count={count} icon={icon} className={!small ? "mr-2" : "mr-1"} />
    <Text variant="caption" className="text-neutral-600">
      {label}
    </Text>
  </span>
);
